import { inject } from '@angular/core';
import { CanDeactivateFn, Router } from '@angular/router';
// Solo tipo: app.routes importa este guard de forma eager y la página es lazy; un import de valor la metería en el bundle principal.
import type { DocumentSubmissionPage } from './document-submission-page';

/**
 * Guard de salida de `documents`. Bloquea ÚNICAMENTE el "atrás/adelante" del navegador (Android back, swipe de iOS)
 * mientras hay un borrado o un envío en curso.
 *
 * Nunca bloquea navegaciones imperativas: la propia página va a `completed` estando en `submitting`, y el interceptor
 * de sesión expirada o `SessionLifecycle` mandan a `expired`/`rfc` en cualquier momento. Bloquearlas dejaría al cliente varado.
 */
export const documentSubmissionLeaveGuard: CanDeactivateFn<DocumentSubmissionPage> = (page) => {
  const trigger = inject(Router).currentNavigation()?.trigger;
  return !(trigger === 'popstate' && page.hasOperationInProgress());
};
